// The one "Line" label for a call, everywhere a call's line is shown (Call Logs Line
// columns, the lead timeline, the call flow / dialer note): "Reading · Existing" from the
// site and the ring group, else the number that was rung in UK format. Pure, so it is
// testable without the components barrel.
import { formatUkPhone } from './ukPhone';

// Connection names that only mean something to us ("Elevate test line", "Simulator"):
// never shown as the site (the call pill keeps the same rule, callPillModel INTERNAL_LINE).
export const INTERNAL_LINE = /\b(simulator|test line)\b/i;

const clean = (v) => (typeof v === 'string' ? v.trim() : '');
const same = (a, b) => Boolean(a) && Boolean(b) && a.toLowerCase() === b.toLowerCase();
const startsWithWord = (text, prefix) => Boolean(text) && Boolean(prefix) && text.toLowerCase().startsWith(`${prefix.toLowerCase()} `);

// `site`: the site / connection display name; `ringGroup`: the ring (hunt) group;
// `siteNumber`: the number that was rung. '' when there is nothing to show.
export function callLineLabel({ site, ringGroup, siteNumber } = {}) {
  const s = INTERNAL_LINE.test(clean(site)) ? '' : clean(site);
  const group = INTERNAL_LINE.test(clean(ringGroup)) ? '' : clean(ringGroup);
  if (group) {
    if (!s || same(s, group)) return group;
    // "Reading" + "Reading Existing" → "Reading · Existing", never the site twice.
    if (startsWithWord(group, s)) return `${s} · ${group.slice(s.length).trim()}`;
    return `${s} · ${group}`;
  }
  return s || (clean(siteNumber) ? formatUkPhone(clean(siteNumber)) : '');
}

// A line label the server already built ("Elevate test line · Reading Existing"): the same
// label with any internal connection name dropped ("Reading Existing"); '' when nothing is left.
export function cleanLineLabel(text) {
  return clean(text).split(/\s+·\s+/).filter((part) => part && !INTERNAL_LINE.test(part)).join(' · ');
}

// The server's own line label ("main · 01908 731705": the line's name and number, every
// channel, CU-869fn2wcn) with the ring group after it when there is one. '' when the server
// sent none (an older backend), so the caller falls back to callLineLabel.
export function serverLineLabel(lineLabel, ringGroup) {
  const line = cleanLineLabel(lineLabel);
  if (!line) return '';
  const group = INTERNAL_LINE.test(clean(ringGroup)) ? '' : clean(ringGroup);
  const parts = line.toLowerCase().split(/\s+·\s+/);
  return group && !parts.includes(group.toLowerCase()) ? `${line} · ${group}` : line;
}
